import { FetchError } from "@medusajs/js-sdk"
import {
  useQuery,
  UseQueryOptions,
  QueryKey,
} from "@tanstack/react-query"
import { useMemo } from "react"
import { sdk } from "../../lib/client"

export type VendorPublishableKeyScheduledRevocationMapping = {
  publishable_api_key_id: string
  scheduled_revoke_at: string
}

type ScheduledRevocationsResponse = {
  mappings: VendorPublishableKeyScheduledRevocationMapping[]
}

export const VENDOR_PUBLISHABLE_KEY_SCHEDULED_REVOCATIONS_QUERY_KEY =
  "admin-vendor-publishable-key-scheduled-revocations" as const

export const useVendorPublishableKeyScheduledRevocations = (
  enabled: boolean,
  options?: Omit<
    UseQueryOptions<
      ScheduledRevocationsResponse,
      FetchError,
      ScheduledRevocationsResponse,
      QueryKey
    >,
    "queryKey" | "queryFn"
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: [VENDOR_PUBLISHABLE_KEY_SCHEDULED_REVOCATIONS_QUERY_KEY],
    queryFn: () =>
      sdk.client.fetch<ScheduledRevocationsResponse>(
        "/admin/vendor-api-key-mappings/scheduled-revocations",
        { method: "GET" }
      ),
    enabled,
    staleTime: 30_000,
    ...options,
  })

  const scheduledRevocationByKeyId = useMemo(() => {
    const next = new Map<string, string>()
    for (const row of data?.mappings ?? []) {
      next.set(row.publishable_api_key_id, row.scheduled_revoke_at)
    }
    return next
  }, [data?.mappings])

  return {
    scheduledRevocationByKeyId,
    mappings: data?.mappings ?? [],
    ...rest,
  }
}
